// import PropTypes from 'prop-types'
import React from 'react'
import {
  Button,
  Loader
} from '../index.js'

const LoaderComponent = () => (<Loader type='absolute' color="red" />)
const Modal = props => (
  <React.Fragment>
    {
      props.isShown ? (
        <div className="modal is-active">
          <div className="modal-background" />
          <div className="modal-card">

            <header className="modal-card-head">
              { props.title && <p className="modal-card-title">{ props.title }</p> }
              { props.onCancelClick &&
                <button className="delete" aria-label="close" onClick={props.onCancelClick}>del</button>
              }
            </header>

            <section className="modal-card-body">
              {
                props.bodyTitle && <p className="modal-card-title">{ props.bodyTitle }</p>
              }
              <div>
                {
                  props.bodyContent && props.bodyContent
                }
              </div>
            </section>
            <footer className="modal-card-foot">
              {
                props.onCancelClick &&
                props.cancelBtnText &&
                <Button
                  outlined
                  btStyle="default"
                  className="is-default"
                  onClick={props.onCancelClick}>
                  {props.cancelBtnText}
                </Button>
              }
              {
                props.onConfirmClick &&
                props.confirmBtnText &&
                <Button
                  btType='danger'
                  btStyle='red'
                  outlined
                  onClick={props.onConfirmClick}
                >
                  {props.confirmBtnText}
                </Button>
              }
            </footer>
            {
              props.loading && <LoaderComponent />
            }
          </div>
        </div>
      ) : null
    }
  </React.Fragment>
)

// Modal.propTypes = {
//   isShown: PropTypes.bool,
//   title: PropTypes.string,
//   loading: PropTypes.bool,
//   bodyTitle: PropTypes.string,
//   bodyContent: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})]),
//   cancelBtnText: PropTypes.string,
//   confirmBtnText: PropTypes.string,
//   onCancelClick: PropTypes.func,
//   onConfirmClick: PropTypes.func
// }

export default Modal



// WEBPACK FOOTER //
// ./components/uiLib/Modal/index.js